import React from "react";
import ClipLoader from "react-spinners/ClipLoader";

import InspectionElement from "../../types/InspectionElement";

import styles from "./ArtifactGrid.module.css";
import ElementAsset from "../../types/ElementAsset";

const styleList = {
    small: styles.small,
    medium: styles.medium,
    large: styles.large,
    remaining: styles.remaining
};

interface Props {
    image: ElementAsset;
    element: InspectionElement;
    type: keyof typeof styleList;
    remaining: string | null;
    openViewerHandler: (
        image: ElementAsset,
        element: InspectionElement
    ) => void;
    openGallery: (data: InspectionElement) => void;
}

export default function GridItem({
    image,
    element,
    type,
    remaining,
    openViewerHandler,
    openGallery
}: Props) {
    const [source, setSource] = React.useState("");
    const [loaded, setLoaded] = React.useState(false);

    React.useEffect(() => {
        const img = new Image();
        img.src = image.url;
        img.onload = () => {
            setSource(image.url);
            setLoaded(true);
        };
    }, [image.url]);

    const selectedStyle = styleList[type];

    function clickHandler() {
        if (remaining) {
            openGallery(element);
        } else {
            openViewerHandler(image, element);
        }
    }
    return loaded ? (
        <div
            onClick={clickHandler}
            data-content={remaining}
            className={selectedStyle}
            style={{ backgroundImage: `url(${source})` }}
        />
    ) : (
        <div
            onClick={clickHandler}
            data-content={remaining}
            className={selectedStyle}
            style={{
                display: "flex",
                justifyContent: "center",
                alignContent: "center",
                alignItems: "center",
                backgroundColor: "#B4B4B4"
            }}
        >
            <ClipLoader color={"#ffffff"} loading={true} size={"50px"} />
        </div>
    );
}
